import { render, staticRenderFns } from "./gatewayEdit.vue?vue&type=template&id=16d61fdc"
import script from "./gatewayEdit.vue?vue&type=script&lang=js"
export * from "./gatewayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports